import React, { useEffect, useState } from 'react';
import './SlideMenu.css';

const SlideMenu = (props) => {
    const [load, setLoad] = useState(false);
    useEffect(() => {
        if(props.menu){
            document.getElementById('slideMenu').style.transform = 'translateX(250px)';
        }
        else if (load){
            document.getElementById('slideMenu').style.transform = 'translateX(-250px)';
        }
        setLoad(true);
    },[props.menu])
    return (
        <div id='slideMenu' className="SM-container">
            <div className="SM-X" onClick={() => props.setMenu(false)}>X</div>
            <div className="SM-options">
                {props.navmenu.map((option) => (<div key={option.id} className="SM-option" onClick={() => {props.setPage(option.id);props.setMenu(false)}}>
                    {option.label}
                </div>))} 
            </div>
        </div>
    )
}

export default SlideMenu;